import { IconButton, InputAdornment } from 'ui'
import CloseIcon from '@mui/icons-material/Close'
import style from './DadataMultiSelectInput.module.scss'

type Props = {
  hasSelectedValues: boolean
  handleCancel: () => void
}

export function DadataMultiSelectAdornment({
  hasSelectedValues,
  handleCancel,
}: Props) {
  return (
    <InputAdornment position='end' className={style.inputActions}>
      {hasSelectedValues && (
        <IconButton
          aria-label='отменить добавление адреса'
          edge='end'
          size='small'
          onClick={handleCancel}
          sx={{ mr: -1 }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      )}
    </InputAdornment>
  )
}
